import React from 'react';

const Legal = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Legal Information
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Important information about our terms, privacy policy, and refund policy
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="prose max-w-none">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Terms of Service</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h3>
            <p className="text-gray-700 mb-6">
              By accessing and using RiseWithilly's website and services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>

            <h3 className="text-xl font-semibold text-gray-900 mb-4">2. Use License</h3>
            <p className="text-gray-700 mb-6">
              Permission is granted to temporarily download one copy of the materials on RiseWithilly's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
            </p>
            <ul className="list-disc list-inside text-gray-700 mb-6 space-y-2">
              <li>modify or copy the materials</li>
              <li>use the materials for any commercial purpose or for any public display</li>
              <li>attempt to reverse engineer any software contained on the website</li>
              <li>remove any copyright or other proprietary notations from the materials</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-900 mb-4">3. Course Access and Usage</h3>
            <p className="text-gray-700 mb-6">
              Upon purchase, you will receive lifetime access to the course materials. You may not share your login credentials or redistribute course content. All course materials are protected by copyright and intellectual property laws.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-6 mt-12">Privacy Policy</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Information We Collect</h3>
            <p className="text-gray-700 mb-6">
              We collect information you provide directly to us, such as when you create an account, make a purchase, or contact us for support. This may include your name, email address, phone number, and payment information.
            </p>

            <h3 className="text-xl font-semibold text-gray-900 mb-4">How We Use Your Information</h3>
            <p className="text-gray-700 mb-6">
              We use the information we collect to provide, maintain, and improve our services, process transactions, send you technical notices and support messages, and communicate with you about products, services, and promotional offers.
            </p>

            <h3 className="text-xl font-semibold text-gray-900 mb-4">Information Sharing</h3>
            <p className="text-gray-700 mb-6">
              We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this privacy policy or as required by law.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-6 mt-12">Refund Policy</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4">30-Day Money-Back Guarantee</h3>
            <p className="text-gray-700 mb-6">
              We offer a 30-day money-back guarantee for all our courses. If you are not satisfied with your purchase, you may request a full refund within 30 days of your purchase date.
            </p>

            <h3 className="text-xl font-semibold text-gray-900 mb-4">Refund Process</h3>
            <p className="text-gray-700 mb-6">
              To request a refund, please contact our support team at karabacakhilal1.1@gmail.com with your order details. Refunds will be processed within 5-7 business days and will be credited to the original payment method.
            </p>

            <h3 className="text-xl font-semibold text-gray-900 mb-4">Refund Conditions</h3>
            <p className="text-gray-700 mb-6">
              Refunds are only available for the first 30 days after purchase. Once you have completed more than 50% of the course content, refunds may not be available. Refunds are not available for courses purchased more than 30 days ago.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-6 mt-12">Frequently Asked Questions</h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">How long do I have access to the course?</h3>
                <p className="text-gray-700">You have lifetime access to all course materials once you purchase a course.</p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Can I download the course materials?</h3>
                <p className="text-gray-700">Course materials are available for online viewing only. Downloading is not permitted to protect intellectual property rights.</p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Do I get a certificate upon completion?</h3>
                <p className="text-gray-700">Yes, you will receive a certificate of completion upon finishing all course modules and assessments.</p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Is there support available?</h3>
                <p className="text-gray-700">Yes, we provide email support for all students. Response time is typically within 24 hours.</p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Can I share my account with others?</h3>
                <p className="text-gray-700">No, sharing account credentials is prohibited. Each student must have their own account.</p>
              </div>
            </div>

            <div className="mt-12 p-6 bg-gray-50 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Contact Information</h3>
              <p className="text-gray-700 mb-2">If you have any questions about these terms, please contact us:</p>
              <p className="text-gray-700">Email: karabacakhilal1.1@gmail.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Legal;
